'use strict';

var React = require('react');

var SvgPointOfSaleIcon = function SvgPointOfSaleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.604 4.907a1.75 1.75 0 0 1 1.716-1.407h7.36a1.75 1.75 0 0 1 1.716 1.407l.6 3a1.75 1.75 0 0 1-1.716 2.093h-1.272l.688 1.722.011.028h1.293c.966 0 1.75.784 1.75 1.75v1.5a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75v-1.5c0-.966.784-1.75 1.75-1.75h1.293a.728.728 0 0 1 .01-.028l.69-1.722h-1.273a1.75 1.75 0 0 1-1.716-2.093l.6-3Zm7.488 6.843h-4.184l.7-1.75h2.784l.7 1.75Zm-5.772-6.75a.25.25 0 0 0-.245.201l-.6 3a.25.25 0 0 0 .245.299h8.56a.25.25 0 0 0 .245-.299l-.6-3a.25.25 0 0 0-.245-.201h-7.36Zm-1.32 8.25a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25h-10Z"
  }));
};
SvgPointOfSaleIcon.displayName = "PointOfSaleIcon";

exports.SvgPointOfSaleIcon = SvgPointOfSaleIcon;
